<div class="input-container">
  <input
    [type]="isDate ? 'date' : 'text'"
    class="search-container"
    [ngClass]="{
      'missing': required && !dataInput,
      'brightness-95': lock,
      'is-table': isTable,
    }"
    (input)="updateFormControl($event)"
    [formControl]="searchControl"
    [placeholder]="isTable ? placeHolder : ''"
  />
  <button
    *ngIf="!isAuto"
    class="search-btn"
    [ngClass]="{
      'disabled': !dataInput && isTable,
      'is-table': isTable,
    }"
    (click)="search($event)"
  >
    <fa-icon [icon]="faSearch" />
  </button>
</div>
